import React from 'react'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

export type ShareDropDownItemButtonProps = Pick<
  StyledButtonProps,
  'disabled' | 'onClick'
> & {
  'data-testid'?: string
  label: string
}

export const ShareDropDownItemButton = ({
  'data-testid': dataTestId = 'components-features-share-drop-down-item-button',
  disabled,
  label,
  onClick,
}: ShareDropDownItemButtonProps) => (
  <StyledButton
    buttonStyle="light"
    data-testid={dataTestId}
    disabled={disabled}
    fillMode="flat"
    onClick={onClick}
  >
    {label}
  </StyledButton>
)
